module.exports = __webpack_public_path__ + "static/media/markup-green.94bea69b.svg";